// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7147":"css/admin-app.6767","9853":"css/app.6767"}[chunkId] + ".css";
};